import { Link } from "react-router-dom";
import type { Topic } from "@/types/content";
import { formatHeat } from "@/utils/format";

interface TopicCardProps {
  topic: Topic;
  layout?: "vertical" | "horizontal";
}

export default function TopicCard({ topic, layout = "vertical" }: TopicCardProps) {
  if (layout === "horizontal") {
    return (
      <article className="group flex flex-col gap-4 rounded-lg border border-background-200 bg-background-50 p-3 transition-colors hover:border-primary-300 sm:flex-row sm:p-4">
        <Link
          to={`/topic/${topic.id}`}
          className="block h-[180px] w-full shrink-0 overflow-hidden rounded-md sm:h-[132px] sm:w-[200px]"
        >
          <img
            src={topic.cover}
            alt={`${topic.title} 相关配图`}
            title={`${topic.title} - 网络爆料`}
            className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-[1.04]"
          />
        </Link>
        <div className="flex min-w-0 flex-1 flex-col">
          <div className="flex flex-wrap items-center gap-2 text-xs">
            <Link
              to={`/rank?category=${topic.categorySlug}`}
              className="rounded-full bg-secondary-100 px-2.5 py-1 text-secondary-800 transition-colors hover:bg-secondary-200"
            >
              {topic.category}
            </Link>
            <span className="text-foreground-500">{topic.publishTime}</span>
          </div>
          <h3 className="mt-2 text-base font-bold leading-snug text-foreground-950">
            <Link to={`/topic/${topic.id}`} className="transition-colors hover:text-primary-600">
              {topic.title}
            </Link>
          </h3>
          <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-foreground-600">
            {topic.summary}
          </p>
          <div className="mt-auto flex items-center gap-4 pt-3 text-xs text-foreground-500">
            <span className="flex items-center gap-1 text-primary-600">
              <i className="ri-fire-fill"></i>
              {formatHeat(topic.heat)}
            </span>
            <span className="flex items-center gap-1">
              <i className="ri-chat-3-line"></i>
              {topic.comments}
            </span>
            <span className="flex items-center gap-1">
              <i className="ri-time-line"></i>
              {topic.readMinutes} 分钟
            </span>
          </div>
        </div>
      </article>
    );
  }

  return (
    <article className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300">
      <Link to={`/topic/${topic.id}`} className="block h-[196px] w-full overflow-hidden">
        <img
          src={topic.cover}
          alt={`${topic.title} 相关配图`}
          title={`${topic.title} - 网络爆料`}
          className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-[1.04]"
        />
      </Link>
      <div className="flex flex-1 flex-col p-4 md:p-5">
        <div className="flex flex-wrap items-center gap-2 text-xs">
          <span className="rounded-full bg-primary-100 px-2.5 py-1 text-primary-700">
            {topic.category}
          </span>
          <span className="text-foreground-500">{topic.publishTime}</span>
        </div>
        <h3 className="mt-3 text-base font-bold leading-snug text-foreground-950">
          <Link to={`/topic/${topic.id}`} className="transition-colors hover:text-primary-600">
            {topic.title}
          </Link>
        </h3>
        <p className="mt-2 line-clamp-3 text-sm leading-relaxed text-foreground-600">
          {topic.summary}
        </p>
        <div className="mt-auto flex items-center gap-4 pt-4 text-xs text-foreground-500">
          <span className="flex items-center gap-1 text-primary-600">
            <i className="ri-fire-fill"></i>
            {formatHeat(topic.heat)}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-chat-3-line"></i>
            {topic.comments}
          </span>
        </div>
      </div>
    </article>
  );
}